import app from 'flarum/forum/app';
import { addProviderTranslations } from '../common/instances';
app.initializers.add('moderndesktop-oauth-forgejo', () => {
  // app.forum is only populated after initializers run.
  app.beforeMount(() => {
    const instances = app.forum.attribute('moderndesktopOauthForgejoInstances') ?? [];
    instances.forEach(({
      name,
      label
    }) => addProviderTranslations(name, label));
  });
});